export const adminFormResetFieldTouched = (condition, adminForm) => {
    adminForm.setFieldTouched("firstName", condition, condition)
    adminForm.setFieldTouched("lastName", condition, condition)
    adminForm.setFieldTouched("email", condition, condition)
    adminForm.setFieldTouched("phoneNumber", condition, condition)
    adminForm.setFieldTouched("role", condition, condition)
}

export const clientFormResetFieldTouched = (condition, clientForm) => {
    clientForm.setFieldTouched("clientCode", condition, condition);
    clientForm.setFieldTouched("name", condition, condition);
    clientForm.setFieldTouched("email", condition, condition);
    clientForm.setFieldTouched("phone", condition, condition);
    clientForm.setFieldTouched("address_1", condition, condition);
    clientForm.setFieldTouched("address_2", condition, condition);
    clientForm.setFieldTouched("state", condition, condition);
    clientForm.setFieldTouched("city", condition, condition);
    clientForm.setFieldTouched("postalCode", condition, condition);
    clientForm.setFieldTouched("gst", condition, condition);
    clientForm.setFieldTouched("pan", condition, condition);
    clientForm.setFieldTouched("tan", condition, condition);
}

export const quotesFormResetFieldTouched = (condition, quotesForm, validateAddContainer) => {
    quotesForm.setFieldTouched("shipmentType", condition, condition)
    quotesForm.setFieldTouched("portOfLoading", condition, condition)
    quotesForm.setFieldTouched("postOfDischarge", condition, condition)
    quotesForm.setFieldTouched("commodity", condition, condition)
    quotesForm.setFieldTouched("cargoReadyDate", condition, condition)
    quotesForm.setFieldTouched("cargoType", condition, condition)
    quotesForm.setFieldTouched('imoDGGlass', condition, condition)
    quotesForm.setFieldTouched('unNumber', condition, condition)
    quotesForm.setFieldTouched('packageCode', condition, condition)
    validateAddContainer(condition)
}

export const userFormResetFieldTouched = (condition, userForm) => {
    userForm.setFieldTouched("firstName", condition, condition)
    userForm.setFieldTouched("lastName", condition, condition)
    userForm.setFieldTouched("email", condition, condition)
    userForm.setFieldTouched("phoneNumber", condition, condition)
    userForm.setFieldTouched("clientCode", condition, condition)
}